import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import LayoutIndex from './layouts';
import PageIndex from './pages';
import PageAbout from './pages/about';
import PageHelpDisableBlocker from './pages/help/disable-blocker';
import PageLikes from './pages/likes';

function App() {
   return (
      <BrowserRouter>
         {/* Main layout */}
         <Switch>
            <Route path="/" exact>
               <LayoutIndex className="index">
                  <PageIndex />
               </LayoutIndex>
            </Route>
            <Route path="/about">
               <LayoutIndex className="about">
                  <PageAbout />
               </LayoutIndex>
            </Route>
            <Route path="/likes">
               <LayoutIndex className="likes">
                  <PageLikes />
               </LayoutIndex>
            </Route>

            <Route path="/help/disable-blocker">
               <LayoutIndex className="help">
                  <PageHelpDisableBlocker />
               </LayoutIndex>
            </Route>

            <Route path="*" exact={true}>
               <LayoutIndex className="404">
                  <Redirect to="/" />
               </LayoutIndex>
            </Route>
         </Switch>
      </BrowserRouter>
   );
}

export default App;
